<script setup lang="ts">
import { useResizeObserver } from '@vueuse/core';
import { MenuIcon } from '@heroicons/vue/outline';

import type { Navigation } from './types';
import MobileMenu from '~/components/Blocks/MobileMenu.vue';
import MobileNavigationMenu from '~/components/Aggregates/Navigation/MobileNavigationMenu.vue';
import MobileNavigationFooter from '~/components/Aggregates/Navigation/MobileNavigationFooter.vue';

defineProps<{
  primaryNavigation?: Navigation[];
}>();

const route = useRoute();

const { setOverflowHidden } = useOverflowHidden();

const show = ref(false);
const mobileMenu = ref(null);

useResizeObserver(mobileMenu, entries => {
  const entry = entries[0];
  const { width } = entry.contentRect;

  if (width >= 640) {
    triggerMobileMenu(false);
  }
});

const triggerMobileMenu = (value: boolean) => {
  show.value = value;
  setOverflowHidden(value);
};

watch(
  () => route.fullPath,
  () => {
    triggerMobileMenu(false);
  }
);
</script>

<template>
  <div class="flex md:hidden">
    <Button
      variant="plain"
      class="flex flex-row items-center gap-2 py-4 pl-0 pr-4 font-medium uppercase text-stormcloud"
      @click="triggerMobileMenu(true)"
    >
      <MenuIcon class="size-7 stroke-2" />
      Menu
    </Button>
    <MobileMenu
      ref="mobileMenu"
      @close="triggerMobileMenu(false)"
      :class="[
        'left-0 top-0 flex h-svh transform flex-col transition-transform',
        show ? 'translate-x-0' : '-translate-x-full'
      ]"
    >
      <template v-slot:content>
        <div class="flex flex-col bg-white">
          <div
            class="flex h-[60px] w-full items-center bg-gunmetal px-5 font-heading uppercase tracking-heading text-white"
          >
            <span>Menu</span>
          </div>
        </div>
        <template v-if="show">
          <div class="flex flex-1 flex-col overflow-hidden">
            <ul class="flex h-full flex-1 flex-col overflow-y-auto bg-white">
              <MobileNavigationMenu
                v-for="navigation in primaryNavigation"
                :key="navigation.label"
                :navigation="navigation"
              />
            </ul>
            <MobileNavigationFooter />
          </div>
        </template>
      </template>
    </MobileMenu>
  </div>
</template>
